import { Link, useLocation } from "react-router-dom";
import {
  HiHome,
  HiCalendar,
  HiChatBubbleLeftRight,
  HiDocument,
} from "react-icons/hi2";
import { useTenantContent } from "../../Context/TenantContentContext";
import { getTenantNavVisibility } from "./tenantNavVisibility";
import { CheckRole } from "../../Services/AuthService";
import "./BottomNav.css";

const BottomNav = () => {
  const location = useLocation();
  const { content, loading } = useTenantContent();
  const { showReservation, showBlog, showConsultation } =
    getTenantNavVisibility(content, loading);
  const isDoctor = CheckRole(["Doctor"]);
  const counselingPath = isDoctor
    ? "/counseling/doctorChats"
    : "/counseling/index";
  const counselingState = isDoctor ? { status: "active" } : undefined;

  const isActive = (path) => {
    if (path === "/" && location.pathname === "/") return true;
    if (path !== "/" && location.pathname.startsWith(path)) return true;
    return false;
  };

  return (
    <>
      <div
        className="d-lg-none bottom-nav fixed-bottom iran-sans pb-0"
        dir="ltr"
      >
        <div className="nav-container">
          {showReservation && (
            <Link
              to="/reservation/reserve"
              className={`nav-item ${
                isActive("/reservation/reserve") ? "active" : ""
              }`}
            >
              <div className="nav-icon-container">
                <HiCalendar className="nav-icon" />
              </div>
              <div className="nav-text">رزرو</div>
            </Link>
          )}

          {showBlog && (
            <Link
              to="/blog/index"
              className={`nav-item ${isActive("/blog") ? "active" : ""}`}
            >
              <div className="nav-icon-container">
                <HiDocument className="nav-icon" />
              </div>
              <div className="nav-text">مقالات</div>
            </Link>
          )}

          {showConsultation && (
            <Link
              to={counselingPath}
              state={counselingState}
              className={`nav-item ${isActive("/counseling") ? "active" : ""}`}
            >
              <div className="nav-icon-container">
                <HiChatBubbleLeftRight className="nav-icon" />
              </div>
              <div className="nav-text">مشاوره</div>
            </Link>
          )}

          <Link to="/" className={`nav-item ${isActive("/") ? "active" : ""}`}>
            <div className="nav-icon-container">
              <HiHome className="nav-icon" />
            </div>
            <div className="nav-text">خانه</div>
          </Link>
        </div>
      </div>
    </>
  );
};

export default BottomNav;
